/**
 * **클립보드에 글자 쓰기 한 곳** — 브라우저 API 를 부르는 경계 어댑터다(Vue·Element·`@/` 별칭 없음).
 *
 * 같은 관용구(`navigator.clipboard` 가 없으면 실패, `writeText` 가 거절되면 실패)가 외부 채널 연동 패널과 콜팝 매장 등록
 * 화면에 복사돼 있었고, 우리동네TV 쿠폰의 랜딩 주소 복사가 세 번째가 될 참이라 여기로 접었다. 성공·실패를 **값으로**
 * 돌려준다 — 어떤 문장으로 알릴지는 화면마다 다르다.
 *
 * @param {string} value 복사할 글자
 * @param {?{writeText: function}} clipboard 기본은 `navigator.clipboard`(시험이 주입한다)
 * @returns {Promise<boolean>} 복사했으면 `true` — 거절돼도 던지지 않는다
 */
export function copyText(value, clipboard = defaultClipboard()) {
  if (!clipboard || typeof clipboard.writeText !== 'function') return Promise.resolve(false)

  return Promise.resolve()
    .then(() => clipboard.writeText(value))
    .then(
      () => true,
      () => false
    )
}

function defaultClipboard() {
  return typeof navigator !== 'undefined' ? navigator.clipboard : null
}
